import clsx from 'clsx'
import useTranslation from 'next-translate/useTranslation'

import useWindowSize from '@/hooks/useWindowSize'
import Product from '@/ts/Product'

import Alert from '../Alert'
import ContestDateTile from './includes/ContestDateTile'

function ExperienceDeadlines({
  product,
  alert,
  orientation,
}: ContestDeadlinesProps) {
  const { t } = useTranslation('products')

  const { width } = useWindowSize()
  const computedOrientation: typeof orientation =
    orientation ?? width >= 600 ? 'horizontal' : 'vertical'

  return (
    <div
      className={clsx(
        'flex mt-6',
        computedOrientation === 'horizontal'
          ? 'space-x-6'
          : 'flex-col items-start space-y-3'
      )}
    >
      {alert ? (
        <Alert message={alert} />
      ) : (
        <>
          <ContestDateTile
            title={t('contest_start')}
            date={product.contest_start}
          />
          <ContestDateTile
            title={t('contest_end')}
            date={product.contest_end}
          />
        </>
      )}
    </div>
  )
}

interface ContestDeadlinesProps {
  product: Product
  alert?: string
  orientation?: 'horizontal' | 'vertical'
}

export default ExperienceDeadlines
